import { useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import './llmPrompts.css';

const fmtNum = (n) => Number(n || 0).toLocaleString('fi-FI');

function CopyButton({ text, label = 'Kopioi' }) {
  const [copied, setCopied] = useState(false);
  return (
    <button
      type="button"
      className="btn btn-sm btn-outline-secondary py-0"
      onClick={() => navigator.clipboard?.writeText(text)
        .then(() => { setCopied(true); setTimeout(() => setCopied(false), 1500); })
        .catch(() => {})}
    >
      <i className="bi bi-clipboard me-1" />{copied ? 'Kopioitu' : label}
    </button>
  );
}

/**
 * Shows the exact OpenAI request body generation would send (preview.request from
 * /api/llm/preview-section — the same object the backend passes to the API).
 * "Viestit" shows each message's content verbatim; "Raaka pyyntö" the whole body as JSON.
 */
export default function PromptPreviewModal({ show, onHide, loading, error, preview }) {
  const [view, setView] = useState('messages');
  const request = preview?.request;
  const rawJson = request ? JSON.stringify(request, null, 2) : '';

  return (
    <Modal show={show} onHide={onHide} size="xl" scrollable>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: '1rem' }}>Mallille lähetettävä prompti</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <Spinner animation="border" size="sm" />}
        {error && <div className="alert alert-danger py-2" style={{ fontSize: '0.85rem' }}>{error}</div>}
        {request && (
          <>
            <div className="d-flex align-items-center gap-2 flex-wrap mb-3">
              <div className="llmp-tabs" role="tablist" style={{ borderBottom: 0 }}>
                <button type="button" role="tab" aria-selected={view === 'messages'} className={`llmp-tab ${view === 'messages' ? 'active' : ''}`} onClick={() => setView('messages')}>Viestit</button>
                <button type="button" role="tab" aria-selected={view === 'raw'} className={`llmp-tab ${view === 'raw' ? 'active' : ''}`} onClick={() => setView('raw')}>Raaka pyyntö (JSON)</button>
              </div>
              <span className="text-muted ms-auto" style={{ fontSize: '0.78rem' }}>
                model: {request.model} · max_tokens: {request.max_tokens} · temperature: {request.temperature} · {fmtNum(preview.chars)} merkkiä ≈ {fmtNum(preview.est_tokens)} tokenia
              </span>
            </div>

            {view === 'messages' && request.messages.map((m, i) => (
              <div key={i} className="mb-3">
                <div className="d-flex align-items-center gap-2 mb-1">
                  <code style={{ fontSize: '0.8rem' }}>messages[{i}].role: "{m.role}"</code>
                  <span className="text-muted" style={{ fontSize: '0.75rem' }}>{fmtNum(m.content.length)} merkkiä</span>
                  <span className="ms-auto"><CopyButton text={m.content} /></span>
                </div>
                <pre className="llmp-preview-text" style={{ maxHeight: 'none' }}>{m.content}</pre>
              </div>
            ))}

            {view === 'raw' && (
              <>
                <div className="d-flex justify-content-end mb-1"><CopyButton text={rawJson} label="Kopioi JSON" /></div>
                <pre className="llmp-preview-text" style={{ maxHeight: 'none' }}>{rawJson}</pre>
              </>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}
